import React from 'react';

import CasinoMaintenanceContainer from 'components/MaintenanceContainer/CasinoMaintenanceContainer';
import CasinoRouter from 'components/Pages/Casino/CasinoRouter';

const MainCasino = () => (
  <CasinoMaintenanceContainer>
    <CasinoRouter />
  </CasinoMaintenanceContainer>
);

export default MainCasino;
